var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleAssetBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.703125,
    y: 0.3125,
    width: 65,
    height: 65,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3169 30.0959L42.186 23.2268L16.5215 8.64752C15.3447 7.97421 14.2615 7.86263 13.4216 8.20065L35.3169 30.0959Z",
    fill: "#302C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7176 11.1172C11.7116 11.2271 11.6953 11.3267 11.6953 11.4416V53.5606C11.6953 53.6133 11.6991 53.6623 11.7008 53.714L33.0076 32.4072L11.7176 11.1172Z",
    fill: "#302C2C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3127 34.7188L13.2656 56.7659C14.1245 57.1736 15.2692 57.0756 16.5173 56.3783L42.3044 41.7104L35.3127 34.7188Z",
    fill: "#302C2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6684 29.7487L45.1332 24.8984L37.625 32.4066L45.2529 40.0345L53.6684 35.2522C56.335 33.7282 56.335 31.2516 53.6684 29.7487Z",
    fill: "#302C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleAssetBottom);
export default __webpack_public_path__ + "static/media/CircleAssetBottom.7745df8e31009a12a5b490a9f79ea0fc.svg";
export { ForwardRef as ReactComponent };